export const version = "1.0.2-daily-20260713-0";
export const channel = "daily";
export const gitcommit = "f60b9129d";
